import type { LoggerFactory } from '@amp/web-apps-logger';
import { makeInvalidationAction } from '@jet-app/music-classical/action-model/InvalidationAction';
import { get } from 'svelte/store';
import {
    CommerceModalActionOperationType,
    makeCommerceModalAction,
} from '~/actions/commerce-modal-action';
import type { Jet } from '~/jet';
import { ContentKind, type PlayAction } from '~/jet/models';
import { CommerceRoute, type Commerce } from '~/utils/commerce';
// Safe because this file is only imported from ./browser.ts
import type { Playback } from '~/utils/playback/browser-only';

export type Dependencies = {
    commerce: Commerce;
    jet: Jet;
    logger: LoggerFactory;
    playback: Playback;
};

export function registerHandler(dependencies: Dependencies) {
    const { commerce, jet, logger, playback } = dependencies;

    const log = logger.loggerFor('jet/action-handlers/play-action');

    jet.onAction('playAction', async (action: PlayAction) => {
        log.info('received PlayAction:', action);
        try {
            const item = action?.items?.length > 0 ? action.items[0] : null;
            const type = item?.type;
            const user = get(commerce.state).user;

            const SHOW_COMMERCE_MODAL_KINDS = [ContentKind.RadioStation];
            const shouldShowCommerceModal =
                user === null &&
                SHOW_COMMERCE_MODAL_KINDS.includes(type as ContentKind);

            if (shouldShowCommerceModal) {
                jet.perform(
                    makeCommerceModalAction({
                        type: CommerceModalActionOperationType.Open,
                        activePath: CommerceRoute.authenticate,
                        modalParams: {
                            contentId: item?.identifiers?.id,
                            contentType: type,
                        },
                    }),
                );
                return 'performed';
            }

            // TODO: Add Capability to pass in multiple items into playback.play and set its queue
            if (type && item) {
                await playback.play(action);
            }
            // Invalidate Recently Played Shelf
            jet.perform(makeInvalidationAction({ kind: 'playActivity' }));

            return 'performed';
        } catch (e) {
            // TODO: rdar://73165545 (Error Handling Across App)
            log.error('error in playAction', e);
        }
    });
}
